
import React from 'react';
import { Tabs } from '@/components/ui/tabs';
import PortfolioTabsHeader from '@/components/portfolio/settings/PortfolioTabsHeader';
import PortfolioTabContent from '@/components/portfolio/settings/PortfolioTabContent';

interface PortfolioSettingsWrapperProps {
  activeTab: string;
  formEdited: boolean;
  isMobile: boolean;
  name: string;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleCancel: () => void;
  handleSave: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  handleTabChange: (value: string) => void;
  billingData: {
    activeBusinesses: any[];
    pausedBusinesses: any[];
    managedBudgets: any[];
    availableCredits: number;
    promotionalDiscount: number;
    billingManager: {
      name: string;
      email: string;
      phone: string;
    } | undefined;
    billingHistory: any[];
    paymentMethods: any[];
    discountCodes: any[];
    totalCharge: number;
    selectedPaymentMethod: string;
    setSelectedPaymentMethod: (id: string) => void;
    handleAddPaymentMethod: () => void;
    handleAddPromoCode: () => void;
    handleMakePrimary: (methodId: string) => void;
    handleChangeBillingManager?: (userId: string) => void;
    formatCurrency: (amount: number) => string;
  };
}

const PortfolioSettingsWrapper = ({
  activeTab,
  formEdited,
  isMobile,
  name,
  handleInputChange,
  handleCancel,
  handleSave,
  handleTabChange,
  billingData
}: PortfolioSettingsWrapperProps) => {
  return (
    <div className="mb-8 w-full overflow-x-hidden">
      <Tabs 
        defaultValue="general" 
        className="w-full" 
        value={activeTab} 
        onValueChange={handleTabChange}
      >
        <PortfolioTabsHeader 
          activeTab={activeTab}
          formEdited={formEdited}
          isMobile={isMobile}
          handleCancel={handleCancel}
          handleSave={handleSave}
        />

        <PortfolioTabContent 
          activeTab={activeTab}
          name={name}
          handleInputChange={handleInputChange}
          billingData={billingData}
          paymentMethods={billingData.paymentMethods}
          discountCodes={billingData.discountCodes}
          totalCharge={billingData.totalCharge}
          selectedPaymentMethod={billingData.selectedPaymentMethod}
          setSelectedPaymentMethod={billingData.setSelectedPaymentMethod}
          handleAddPaymentMethod={billingData.handleAddPaymentMethod}
          handleAddPromoCode={billingData.handleAddPromoCode}
          handleMakePrimary={billingData.handleMakePrimary}
          handleChangeBillingManager={billingData.handleChangeBillingManager}
          formatCurrency={billingData.formatCurrency}
        />
      </Tabs>
    </div>
  );
};

export default PortfolioSettingsWrapper;
